/**
 * MapStyleSwitcher — Sprint 4.2B.
 *
 * Dropdown compacto top-left do mapa para alternar entre os 4 estilos
 * de basemap.
 */
import { useState } from "react";

import { TILE_PROVIDERS } from "./tileProviders.js";

export default function MapStyleSwitcher({ currentStyle, onChange }) {
  const [open, setOpen] = useState(false);

  const handlePick = (id) => {
    setOpen(false);
    if (id !== currentStyle) onChange(id);
  };

  return (
    <div className="ipwd-style-switcher">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="ipwd-style-switcher-trigger"
        title="Alterar tipo de mapa (basemap)"
      >
        {/* M1.3B item 4(b) — rótulo fixo "🗺 Mapa" (dropdown = tipo de mapa;
            o toggle Normal/Concentrado = modo de visualização). As opções
            Normal/Satélite/Dark/Operacional seguem no menu, sem mudança. */}
        <span className="ipwd-style-switcher-icon">🗺</span>
        <span className="ipwd-style-switcher-label">Mapa</span>
        <span className="ipwd-style-switcher-chev">{open ? "▲" : "▼"}</span>
      </button>

      {open && (
        <div className="ipwd-style-switcher-menu">
          {Object.values(TILE_PROVIDERS).map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => handlePick(p.id)}
              className={`ipwd-style-switcher-item ${currentStyle === p.id ? "is-active" : ""}`}
            >
              <span className="ipwd-style-switcher-icon">{p.icon}</span>
              <span className="ipwd-style-switcher-label">{p.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
